var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noDataBox"},[(_vm.type == 'noFile')?_c('div',{staticClass:"noFile"},[_c('h3',[_vm._v(_vm._s(_vm.$t('leftPane.supportMov')))]),_c('span',[_vm._v(_vm._s(_vm.$t('leftPane.clickBtn')))]),_c('span',[_vm._v(_vm._s(_vm.$t('leftPane.fileUpload')))]),_c('upload-file',{attrs:{"type":"btn"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }